import { render, staticRenderFns } from "./JobAgentSection.vue?vue&type=template&id=4b16a7ac&scoped=true&"
import script from "./JobAgentSection.vue?vue&type=script&lang=js&"
export * from "./JobAgentSection.vue?vue&type=script&lang=js&"
import style0 from "./JobAgentSection.vue?vue&type=style&index=0&id=4b16a7ac&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16a7ac",
  null
  
)

export default component.exports